export const defaultNominalWeight = 60;

// These are crop constants that are specifically needed to be referenced by code.
export const cropIds = {
  'CORN': 133128,
  'SOYBEAN': 133165,
  'OTHER': 150492,
  'WHEAT_HARD_WHITE_WINTER': 133438
};

// This the list of crops supported by web, this is a hardcoded list due to the fact that
// at this time there is no master crop list on the backend: https://climate.jira.com/browse/ARTCAP-601
// This will eventually be replaced for a call to Sprout.
export const SUPPORTED_CROPS = [
  {
    'updated-at': '2022-01-27T22:11:42.922Z',
    'nominal-weight': {
      'q': 44,
      'u': 'pound/bushel'
    },
    'name': 'Hemp',
    'legacy-id': 162515,
    'product-type': 'variety',
    'code': 'hemp',
    'uuid': 'fc9c9e73-5d97-11e7-ba9f-0e5557d5dd85',
    'dfp-uuid': '5c2942dc-3668-4bde-aaf8-124f3e5f3429'
  },
  {
    'updated-at': '2018-10-03T19:04:45.000Z',
    'nominal-weight': {
      'q': 60,
      'u': 'pound/bushel'
    },
    'name': 'Oilseed, Rape Winter',
    'legacy-id': 150491,
    'product-type': 'variety',
    'code': 'oilseed-winter',
    'uuid': '6daf6d58-487d-11e6-a640-0e5557d5dd85',
    'dfp-uuid': 'acbd157b-2171-4ffa-8ef0-0dfbb0ccc40e',
    'nominal-moisture': {
      'q': 10,
      'u': 'percent'
    }
  },
  {
    'updated-at': '2018-07-30T18:10:10.000Z',
    'nominal-weight': {
      'q': 60,
      'u': 'pound/bushel'
    },
    'name': 'Wheat, Soft White Spring',
    'legacy-id': 133439,
    'source': {
      'code': 'agx',
      'id': '392'
    },
    'product-type': 'variety',
    'code': 'wheat-soft-white-spring',
    'uuid': '6611bbcb-487d-11e6-a640-0e5557d5dd85',
    'dfp-uuid': '37f45f22-bc2c-4c7a-a114-25d7a81474dd',
    'nominal-moisture': {
      'q': 13.5,
      'u': 'percent'
    }
  },
  {
    'updated-at': '2018-09-06T17:16:24.000Z',
    'nominal-weight': {
      'q': 60,
      'u': 'pound/bushel'
    },
    'name': 'Wheat, Hard White Winter',
    'legacy-id': 133438,
    'source': {
      'code': 'agx',
      'id': '391'
    },
    'product-type': 'variety',
    'code': 'wheat-winter',
    'uuid': '6611bbb8-487d-11e6-a640-0e5557d5dd85',
    'dfp-uuid': '47809c70-4ba6-4fe1-8670-a7ed7626c780',
    'nominal-moisture': {
      'q': 13.5,
      'u': 'percent'
    }
  },
  {
    'updated-at': '2018-07-30T18:10:10.000Z',
    'nominal-weight': {
      'q': 60,
      'u': 'pound/bushel'
    },
    'name': 'Lentils, Green',
    'legacy-id': 162517,
    'product-type': 'variety',
    'code': 'lentils-green',
    'uuid': '98452080-667b-11e7-ba9f-0e5557d5dd85',
    'dfp-uuid': '3af50778-7bb3-4024-b142-14ee1d39df83',
    'nominal-moisture': {
      'q': 16,
      'u': 'percent'
    }
  },
  {
    'updated-at': '2018-09-06T17:16:24.000Z',
    'nominal-weight': {
      'q': 60,
      'u': 'pound/bushel'
    },
    'name': 'Wheat, Canada Prairie Spring Red',
    'legacy-id': 133422,
    'source': {
      'code': 'agx',
      'id': '373'
    },
    'product-type': 'variety',
    'code': 'wheat-canada-prairie-spring-red',
    'uuid': '6611ba8e-487d-11e6-a640-0e5557d5dd85',
    'dfp-uuid': '8f4b37ac-960e-4cd3-af57-6aa9bd9899cd',
    'nominal-moisture': {
      'q': 13.5,
      'u': 'percent'
    }
  },
  {
    'updated-at': '2016-09-21T21:17:19.000Z',
    'name': 'Watermelon',
    'legacy-id': 133176,
    'source': {
      'code': 'agx',
      'id': '59'
    },
    'product-type': 'variety',
    'code': 'watermelon',
    'uuid': '6611a886-487d-11e6-a640-0e5557d5dd85',
    'dfp-uuid': '2094c8eb-6527-49ae-82bb-e891f4afc360'
  },
  {
    'updated-at': '2022-01-27T22:11:42.392Z',
    'nominal-weight': {
      'q': 50,
      'u': 'pound/bushel'
    },
    'name': 'Canaryseed',
    'legacy-id': 133408,
    'source': {
      'code': 'agx',
      'id': '358'
    },
    'product-type': 'variety',
    'code': 'canary-seed',
    'uuid': '6611b98a-487d-11e6-a640-0e5557d5dd85',
    'dfp-uuid': 'c2e58d37-f558-4e70-a772-96f7838bc960'
  },
  {
    'updated-at': '2022-01-27T22:11:44.318Z',
    'nominal-weight': {
      'q': 50,
      'u': 'pound/bushel'
    },
    'name': 'Triticale',
    'legacy-id': 133174,
    'source': {
      'code': 'agx',
      'id': '57'
    },
    'product-type': 'variety',
    'code': 'triticale',
    'uuid': '6611a860-487d-11e6-a640-0e5557d5dd85',
    'dfp-uuid': 'e64633d1-4caa-4fe5-a5c2-e2043a7219f8'
  },
  {
    'updated-at': '2019-01-10T21:14:44.000Z',
    'nominal-weight': {
      'q': 60,
      'u': 'pound/bushel'
    },
    'name': 'Bean, Pinto',
    'legacy-id': 133366,
    'source': {
      'code': 'agx',
      'id': '312'
    },
    'product-type': 'variety',
    'code': 'beans-pinto',
    'uuid': '6611b67d-487d-11e6-a640-0e5557d5dd85',
    'dfp-uuid': 'faf3e5c7-eafa-47e2-889f-2ba863904b9c',
    'nominal-moisture': {
      'q': 16,
      'u': 'percent'
    }
  },
  {
    'updated-at': '2016-09-21T21:17:19.000Z',
    'nominal-weight': {
      'q': 60,
      'u': 'pound/bushel'
    },
    'name': 'Soybeans',
    'legacy-id': 133165,
    'source': {
      'code': 'agx',
      'id': '48'
    },
    'product-type': 'variety',
    'code': 'soybeans',
    'uuid': '6611a7b5-487d-11e6-a640-0e5557d5dd85',
    'dfp-uuid': '8be6dd5d-b5e9-4fc7-b5fc-f80309ee0f13',
    'nominal-moisture': {
      'q': 13,
      'u': 'percent'
    }
  },
  {
    'updated-at': '2016-09-21T21:17:19.000Z',
    'nominal-weight': {
      'q': 60,
      'u': 'pound/bushel'
    },
    'name': 'Popcorn, Yellow',
    'shrink-factor': 1.2,
    'legacy-id': 133154,
    'source': {
      'code': 'agx',
      'id': '37'
    },
    'product-type': 'hybrid',
    'code': 'popcorn-yellow',
    'uuid': '6611a6e5-487d-11e6-a640-0e5557d5dd85',
    'dfp-uuid': 'd186e458-dac2-4d8b-a7c6-18f2980a79b1',
    'nominal-moisture': {
      'q': 14,
      'u': 'percent'
    }
  },
  {
    'updated-at': '2018-11-08T19:00:44.000Z',
    'nominal-weight': {
      'q': 28,
      'u': 'pound/bushel'
    },
    'name': 'Sunflowers',
    'legacy-id': 150702,
    'product-type': '',
    'code': 'sunflowers',
    'uuid': '6daf73ac-487d-11e6-a640-0e5557d5dd85',
    'dfp-uuid': '644b1f4c-d436-494b-b412-cde95d4013d9',
    'nominal-moisture': {
      'q': 14,
      'u': 'percent'
    }
  },
  {
    'updated-at': '2016-09-21T21:17:18.000Z',
    'nominal-weight': {
      'q': 48,
      'u': 'pound/bushel'
    },
    'name': 'Cucumber',
    'legacy-id': 133131,
    'source': {
      'code': 'agx',
      'id': '14'
    },
    'product-type': 'variety',
    'code': 'cucumber',
    'uuid': '6611a52e-487d-11e6-a640-0e5557d5dd85',
    'dfp-uuid': '964fc8a9-f730-48e8-a807-de380a73fbea'
  },
  {
    'updated-at': '2016-09-21T21:17:18.000Z',
    'nominal-weight': {
      'q': 48,
      'u': 'pound/bushel'
    },
    'name': 'Barley',
    'legacy-id': 133119,
    'source': {
      'code': 'agx',
      'id': '2'
    },
    'product-type': 'variety',
    'code': 'barley',
    'uuid': '6611a43c-487d-11e6-a640-0e5557d5dd85',
    'dfp-uuid': '466b26cb-7452-48ed-bec4-9b6b49fd7357',
    'nominal-moisture': {
      'q': 14,
      'u': 'percent'
    }
  },
  {
    'updated-at': '2018-09-06T17:16:24.000Z',
    'nominal-weight': {
      'q': 60,
      'u': 'pound/bushel'
    },
    'name': 'Wheat',
    'legacy-id': 133177,
    'source': {
      'code': 'agx',
      'id': '60'
    },
    'product-type': 'variety',
    'code': 'wheat',
    'uuid': '6611a899-487d-11e6-a640-0e5557d5dd85',
    'dfp-uuid': 'b2d64a59-8870-4e96-914c-e4dcb0425da0',
    'nominal-moisture': {
      'q': 13.5,
      'u': 'percent'
    }
  },
  {
    'updated-at': '2016-09-21T21:17:19.000Z',
    'nominal-weight': {
      'q': 52,
      'u': 'pound/bushel'
    },
    'name': 'Sugarbeets',
    'legacy-id': 133168,
    'source': {
      'code': 'agx',
      'id': '51'
    },
    'product-type': 'variety',
    'code': 'sugarbeets',
    'uuid': '6611a7ee-487d-11e6-a640-0e5557d5dd85',
    'dfp-uuid': '1dc24680-2b54-47f2-9c58-ec4c321e6a4b'
  },
  {
    'updated-at': '2016-09-21T21:17:19.000Z',
    'nominal-weight': {
      'q': 50,
      'u': 'pound/bushel'
    },
    'name': 'Radish',
    'legacy-id': 133291,
    'source': {
      'code': 'agx',
      'id': '226'
    },
    'product-type': 'variety',
    'code': 'radish',
    'uuid': '6611b109-487d-11e6-a640-0e5557d5dd85',
    'dfp-uuid': '3657c7e8-27ae-4f10-89d3-8433389c1b55',
    'nominal-moisture': {
      'q': 10,
      'u': 'percent'
    }
  },
  {
    'updated-at': '2022-01-27T22:11:42.035Z',
    'nominal-weight': {
      'q': 56,
      'u': 'pound/bushel'
    },
    'name': 'Bean, Black',
    'legacy-id': 162519,
    'product-type': 'variety',
    'code': 'beans-black',
    'uuid': '984520b3-667b-11e7-ba9f-0e5557d5dd85',
    'dfp-uuid': '1306149c-310d-46ce-8d63-d76847e7f99c'
  },
  {
    'updated-at': '2016-09-21T21:17:18.000Z',
    'nominal-weight': {
      'q': 50,
      'u': 'pound/bushel'
    },
    'name': 'Millet, Pearl',
    'legacy-id': 133156,
    'source': {
      'code': 'agx',
      'id': '39'
    },
    'product-type': 'variety',
    'code': 'millet',
    'uuid': '6611a70b-487d-11e6-a640-0e5557d5dd85',
    'dfp-uuid': '19eeea47-2c1c-4307-ac25-4896a1482e60',
    'nominal-moisture': {
      'q': 10,
      'u': 'percent'
    }
  },
  {
    'updated-at': '2018-07-30T18:10:10.000Z',
    'nominal-weight': {
      'q': 60,
      'u': 'pound/bushel'
    },
    'name': 'Peas, Green',
    'legacy-id': 150680,
    'product-type': '',
    'code': 'peas-green',
    'uuid': '6daf7204-487d-11e6-a640-0e5557d5dd85',
    'dfp-uuid': '91b7560a-1ff2-4fbd-b290-830a17883bc9',
    'nominal-moisture': {
      'q': 16,
      'u': 'percent'
    }
  },
  {
    'updated-at': '2017-04-03T19:50:59.000Z',
    'name': 'Quinoa',
    'legacy-id': 161583,
    'product-type': 'variety',
    'code': 'quinoa',
    'uuid': 'a39a17e4-18a2-11e7-a640-0e5557d5dd85',
    'dfp-uuid': 'afc2c2e3-e4db-43ac-95c3-9bc088eaaf8e'
  },
  {
    'updated-at': '2018-10-03T19:04:45.000Z',
    'nominal-weight': {
      'q': 60,
      'u': 'pound/bushel'
    },
    'name': 'Oilseed, Rape Spring',
    'legacy-id': 150719,
    'product-type': 'variety',
    'code': 'oilseed-spring',
    'uuid': '6daf6dc3-487d-11e6-a640-0e5557d5dd85',
    'dfp-uuid': '1715a2e8-8bfb-4ca7-9c8b-f700af431358',
    'nominal-moisture': {
      'q': 10,
      'u': 'percent'
    }
  },
  {
    'updated-at': '2016-09-21T21:17:18.000Z',
    'nominal-weight': {
      'q': 30,
      'u': 'pound/bushel'
    },
    'name': 'Bean, Green',
    'legacy-id': 133139,
    'source': {
      'code': 'agx',
      'id': '22'
    },
    'product-type': 'variety',
    'code': 'beans-green',
    'uuid': '6611a5c9-487d-11e6-a640-0e5557d5dd85',
    'dfp-uuid': '30dbd6a5-6c72-4b08-8de3-b721a80ccbf9'
  },
  {
    'updated-at': '2016-09-21T21:17:18.000Z',
    'nominal-weight': {
      'q': 60,
      'u': 'pound/bushel'
    },
    'name': 'Peanuts',
    'legacy-id': 133150,
    'source': {
      'code': 'agx',
      'id': '33'
    },
    'product-type': 'variety',
    'code': 'peanuts',
    'uuid': '6611a699-487d-11e6-a640-0e5557d5dd85',
    'dfp-uuid': 'e13355f6-d4c8-4d12-bdd8-fb2541c39097',
    'nominal-moisture': {
      'q': 10,
      'u': 'percent'
    }
  },
  {
    'updated-at': '2016-09-21T21:17:19.000Z',
    'nominal-weight': {
      'q': 56,
      'u': 'pound/bushel'
    },
    'name': 'Rye',
    'legacy-id': 133161,
    'source': {
      'code': 'agx',
      'id': '44'
    },
    'product-type': 'variety',
    'code': 'rye',
    'uuid': '6611a769-487d-11e6-a640-0e5557d5dd85',
    'dfp-uuid': '02a28e12-7d6a-48ca-89c9-a327fb64cd2c',
    'nominal-moisture': {
      'q': 14,
      'u': 'percent'
    }
  },
  {
    'updated-at': '2016-09-21T21:17:18.000Z',
    'nominal-weight': {
      'q': 52,
      'u': 'pound/bushel'
    },
    'name': 'Canola',
    'legacy-id': 133123,
    'source': {
      'code': 'agx',
      'id': '6'
    },
    'product-type': 'variety',
    'code': 'canola',
    'uuid': '6611a494-487d-11e6-a640-0e5557d5dd85',
    'dfp-uuid': '9301eee4-6680-4deb-8bfc-2f07fba355ee',
    'nominal-moisture': {
      'q': 10,
      'u': 'percent'
    }
  },
  {
    'updated-at': '2016-09-21T21:17:19.000Z',
    'nominal-weight': {
      'q': 60,
      'u': 'pound/bushel'
    },
    'name': 'Popcorn, White',
    'shrink-factor': 1.2,
    'legacy-id': 133409,
    'source': {
      'code': 'agx',
      'id': '359'
    },
    'product-type': 'hybrid',
    'code': 'popcorn-white',
    'uuid': '6611b99d-487d-11e6-a640-0e5557d5dd85',
    'dfp-uuid': 'a0187014-260e-4bc9-90ed-c5108757a5dc',
    'nominal-moisture': {
      'q': 14,
      'u': 'percent'
    }
  },
  {
    'updated-at': '2018-07-30T18:10:10.000Z',
    'nominal-weight': {
      'q': 60,
      'u': 'pound/bushel'
    },
    'name': 'Wheat, Soft White Winter',
    'legacy-id': 133440,
    'source': {
      'code': 'agx',
      'id': '393'
    },
    'product-type': 'variety',
    'code': 'wheat-soft-white-winter',
    'uuid': '6611bbde-487d-11e6-a640-0e5557d5dd85',
    'dfp-uuid': '4595b093-686b-4ff5-95ac-86ba071e3aae',
    'nominal-moisture': {
      'q': 13.5,
      'u': 'percent'
    }
  },
  {
    'updated-at': '2018-10-30T20:33:24.000Z',
    'nominal-weight': {
      'q': 28,
      'u': 'pound/bushel'
    },
    'name': 'Sunflower, Confectionery',
    'legacy-id': 133169,
    'source': {
      'code': 'agx',
      'id': '52'
    },
    'product-type': 'variety',
    'code': 'sunflower-confectionery',
    'uuid': '6611a801-487d-11e6-a640-0e5557d5dd85',
    'dfp-uuid': '3dd253dc-a651-4c74-9251-b3509c855cef',
    'nominal-moisture': {
      'q': 14,
      'u': 'percent'
    }
  },
  {
    'updated-at': '2022-01-27T22:11:42.658Z',
    'nominal-weight': {
      'q': 22,
      'u': 'pound/bushel'
    },
    'name': 'Grass, Seed',
    'legacy-id': 150718,
    'product-type': 'variety',
    'code': 'grass-seed',
    'uuid': '6daf6daf-487d-11e6-a640-0e5557d5dd85',
    'dfp-uuid': '0191b662-32ef-46cc-a508-16f101823869',
    'nominal-moisture': {
      'q': 10,
      'u': 'percent'
    }
  },
  {
    'updated-at': '2016-09-21T21:17:18.000Z',
    'nominal-weight': {
      'q': 60,
      'u': 'pound/bushel'
    },
    'name': 'Peas',
    'legacy-id': 133151,
    'source': {
      'code': 'agx',
      'id': '34'
    },
    'product-type': 'variety',
    'code': 'peas',
    'uuid': '6611a6ac-487d-11e6-a640-0e5557d5dd85',
    'dfp-uuid': 'ee0770b1-d763-4f2e-9ccd-3fa792c0cb17',
    'nominal-moisture': {
      'q': 10,
      'u': 'percent'
    }
  },
  {
    'updated-at': '2018-10-30T20:32:08.000Z',
    'nominal-weight': {
      'q': 25,
      'u': 'pound/bushel'
    },
    'name': 'Sunflower, Oilseed',
    'legacy-id': 133170,
    'source': {
      'code': 'agx',
      'id': '53'
    },
    'product-type': 'variety',
    'code': 'sunflower-oilseed',
    'uuid': '6611a814-487d-11e6-a640-0e5557d5dd85',
    'dfp-uuid': 'd9328594-de94-4338-a604-1548d740da41',
    'nominal-moisture': {
      'q': 14,
      'u': 'percent'
    }
  },
  {
    'updated-at': '2016-09-21T21:17:18.000Z',
    'nominal-weight': {
      'q': 22,
      'u': 'pound/bushel'
    },
    'name': 'Meadowfoam',
    'legacy-id': 133414,
    'source': {
      'code': 'agx',
      'id': '364'
    },
    'product-type': 'variety',
    'code': 'meadowfoam',
    'uuid': '6611b9fa-487d-11e6-a640-0e5557d5dd85',
    'dfp-uuid': '2faf67b2-c508-4d27-b1f4-2bf33d0d8df1',
    'nominal-moisture': {
      'q': 10,
      'u': 'percent'
    }
  },
  {
    'updated-at': '2016-09-21T21:17:19.000Z',
    'nominal-weight': {
      'q': 40,
      'u': 'pound/bushel'
    },
    'name': 'Squash, Summer',
    'legacy-id': 133303,
    'source': {
      'code': 'agx',
      'id': '241'
    },
    'product-type': 'variety',
    'code': 'squash-summer',
    'uuid': '6611b1e9-487d-11e6-a640-0e5557d5dd85',
    'dfp-uuid': '27538fe0-f117-423f-836a-82b4ea5157df'
  },
  {
    'updated-at': '2019-11-25T20:17:44.559Z',
    'name': 'Silage Corn',
    'shrink-factor': 1,
    'legacy-id': 161584,
    'product-type': 'hybrid',
    'code': 'corn-silage',
    'uuid': 'dd63388b-1bc4-11e7-a640-0e5557d5dd85',
    'dfp-uuid': '46b127c3-1f48-4ce7-8d04-61129e516856',
    'nominal-moisture': {
      'q': 65,
      'u': 'percent'
    }
  },
  {
    'updated-at': '2016-09-21T21:17:19.000Z',
    'nominal-weight': {
      'q': 45,
      'u': 'pound/bushel'
    },
    'name': 'Rice, Long',
    'legacy-id': 133159,
    'source': {
      'code': 'agx',
      'id': '42'
    },
    'product-type': 'variety',
    'code': 'rice',
    'uuid': '6611a744-487d-11e6-a640-0e5557d5dd85',
    'dfp-uuid': '7224418d-b498-4975-9c5e-1e01e71f0b03',
    'nominal-moisture': {
      'q': 14,
      'u': 'percent'
    }
  },
  {
    'updated-at': '2019-11-25T19:12:21.024Z',
    'nominal-weight': {
      'q': 60,
      'u': 'pound/bushel'
    },
    'name': 'Bean, Navy',
    'legacy-id': 133390,
    'source': {
      'code': 'agx',
      'id': '338'
    },
    'product-type': 'variety',
    'code': 'beans-navy',
    'uuid': '6611b83b-487d-11e6-a640-0e5557d5dd85',
    'dfp-uuid': '54562f71-89a1-4bb7-8386-5576e7fecc72'
  },
  {
    'updated-at': '2016-09-21T21:17:18.000Z',
    'name': 'Fallow',
    'legacy-id': 133136,
    'source': {
      'code': 'agx',
      'id': '19'
    },
    'product-type': 'variety',
    'code': 'fallow',
    'uuid': '6611a58f-487d-11e6-a640-0e5557d5dd85',
    'dfp-uuid': '4e6b0736-cd92-4e78-9257-28dc60f1ea83'
  },
  {
    'updated-at': '2022-01-27T22:11:44.059Z',
    'nominal-weight': {
      'q': 11,
      'u': 'pound/bushel'
    },
    'name': 'Sugarcane',
    'legacy-id': 133305,
    'source': {
      'code': 'agx',
      'id': '243'
    },
    'product-type': 'variety',
    'code': 'sugarcane',
    'uuid': '6611b20e-487d-11e6-a640-0e5557d5dd85',
    'dfp-uuid': 'de62707e-b3d1-4583-9f7e-7e4a4957dc62'
  },
  {
    'updated-at': '2016-09-21T21:17:18.000Z',
    'nominal-weight': {
      'q': 56,
      'u': 'pound/bushel'
    },
    'name': 'Flax',
    'legacy-id': 133336,
    'source': {
      'code': 'agx',
      'id': '281'
    },
    'product-type': 'variety',
    'code': 'flax',
    'uuid': '6611b44f-487d-11e6-a640-0e5557d5dd85',
    'dfp-uuid': 'ade62c08-4071-4584-9356-d1912aac7f21',
    'nominal-moisture': {
      'q': 7,
      'u': 'percent'
    }
  },
  {
    'updated-at': '2016-09-21T21:17:18.000Z',
    'nominal-weight': {
      'q': 60,
      'u': 'pound/bushel'
    },
    'name': 'Potatoes',
    'legacy-id': 133155,
    'source': {
      'code': 'agx',
      'id': '38'
    },
    'product-type': 'variety',
    'code': 'potatoes',
    'uuid': '6611a6f8-487d-11e6-a640-0e5557d5dd85',
    'dfp-uuid': '7dc320cb-5a5b-49f9-aa6c-a84f05ac4ef6'
  },
  {
    'updated-at': '2016-09-21T21:17:18.000Z',
    'name': 'Garlic',
    'legacy-id': 133233,
    'source': {
      'code': 'agx',
      'id': '162'
    },
    'product-type': 'variety',
    'code': 'garlic',
    'uuid': '6611acd1-487d-11e6-a640-0e5557d5dd85',
    'dfp-uuid': 'fc0e4f9e-d178-4737-bfb7-edeee0d2e907'
  },
  {
    'updated-at': '2016-09-21T21:17:19.000Z',
    'name': 'Other',
    'legacy-id': 150492,
    'product-type': 'hybrid-variety',
    'code': 'other',
    'uuid': '6daf6d71-487d-11e6-a640-0e5557d5dd85',
    'dfp-uuid': '4815d25f-5a12-4c73-b475-d1bd37caecfd'
  },
  {
    'updated-at': '2018-07-30T18:10:10.000Z',
    'nominal-weight': {
      'q': 60,
      'u': 'pound/bushel'
    },
    'name': 'Lentils, Red',
    'legacy-id': 162516,
    'product-type': 'variety',
    'code': 'lentils-red',
    'uuid': '98451ff9-667b-11e7-ba9f-0e5557d5dd85',
    'dfp-uuid': '61ad21d6-ec28-44c2-b912-7c64b3d99aeb',
    'nominal-moisture': {
      'q': 16,
      'u': 'percent'
    }
  },
  {
    'updated-at': '2016-09-21T21:17:19.000Z',
    'name': 'Pumpkins',
    'legacy-id': 133158,
    'source': {
      'code': 'agx',
      'id': '41'
    },
    'product-type': 'variety',
    'code': 'pumpkin',
    'uuid': '6611a731-487d-11e6-a640-0e5557d5dd85',
    'dfp-uuid': '3e3c11e1-f93a-4dfe-a36f-d5d035c9ac39'
  },
  {
    'updated-at': '2018-07-30T18:10:10.000Z',
    'nominal-weight': {
      'q': 60,
      'u': 'pound/bushel'
    },
    'name': 'Wheat, Soft Red Spring',
    'legacy-id': 162518,
    'product-type': 'variety',
    'code': 'wheat-soft-red-spring',
    'uuid': '9845209b-667b-11e7-ba9f-0e5557d5dd85',
    'dfp-uuid': '0c045d90-c658-48f9-9741-39c08d63a401',
    'nominal-moisture': {
      'q': 13.5,
      'u': 'percent'
    }
  },
  {
    'updated-at': '2018-07-30T18:10:09.000Z',
    'nominal-weight': {
      'q': 60,
      'u': 'pound/bushel'
    },
    'name': 'Wheat, Durum',
    'legacy-id': 133337,
    'source': {
      'code': 'agx',
      'id': '282'
    },
    'product-type': 'variety',
    'code': 'wheat-durum',
    'uuid': '6611b462-487d-11e6-a640-0e5557d5dd85',
    'dfp-uuid': '8743fe11-5de5-43dc-99d9-c5eb07513a50',
    'nominal-moisture': {
      'q': 13.5,
      'u': 'percent'
    }
  },
  {
    'updated-at': '2016-09-21T21:17:18.000Z',
    'nominal-weight': {
      'q': 50,
      'u': 'pound/bushel'
    },
    'name': 'Potato, Sweet',
    'legacy-id': 133287,
    'source': {
      'code': 'agx',
      'id': '222'
    },
    'product-type': 'variety',
    'code': 'potatoes-sweet',
    'uuid': '6611b0bf-487d-11e6-a640-0e5557d5dd85',
    'dfp-uuid': '724a8f43-d1a7-42aa-9052-2c2a500a80ae'
  },
  {
    'updated-at': '2016-09-21T21:17:19.000Z',
    'nominal-weight': {
      'q': 56,
      'u': 'pound/bushel'
    },
    'name': 'Corn',
    'shrink-factor': 1.2,
    'legacy-id': 133128,
    'source': {
      'code': 'agx',
      'id': '11'
    },
    'product-type': 'hybrid',
    'code': 'corn',
    'uuid': '6611a4f5-487d-11e6-a640-0e5557d5dd85',
    'dfp-uuid': 'c7093350-c426-4c02-b1f9-316d871800ab',
    'nominal-moisture': {
      'q': 15.5,
      'u': 'percent'
    }
  },
  {
    'updated-at': '2016-09-21T21:17:19.000Z',
    'nominal-weight': {
      'q': 40,
      'u': 'pound/bushel'
    },
    'name': 'Squash, Winter',
    'legacy-id': 133304,
    'source': {
      'code': 'agx',
      'id': '242'
    },
    'product-type': 'variety',
    'code': 'squash-winter',
    'uuid': '6611b1fb-487d-11e6-a640-0e5557d5dd85',
    'dfp-uuid': '862738fd-1c91-441e-9f09-24af5bc763ef'
  },
  {
    'updated-at': '2018-07-30T18:10:09.000Z',
    'nominal-weight': {
      'q': 60,
      'u': 'pound/bushel'
    },
    'name': 'Wheat, Soft Red Winter',
    'legacy-id': 133404,
    'source': {
      'code': 'agx',
      'id': '354'
    },
    'product-type': 'variety',
    'code': 'wheat-soft-red-winter',
    'uuid': '6611b940-487d-11e6-a640-0e5557d5dd85',
    'dfp-uuid': 'ed529f07-8816-4d87-b3a5-8053da8afe59',
    'nominal-moisture': {
      'q': 13.5,
      'u': 'percent'
    }
  },
  {
    'updated-at': '2016-09-21T21:17:18.000Z',
    'nominal-weight': {
      'q': 32,
      'u': 'pound/bushel'
    },
    'name': 'Oats',
    'legacy-id': 133147,
    'source': {
      'code': 'agx',
      'id': '30'
    },
    'product-type': 'variety',
    'code': 'oats',
    'uuid': '6611a661-487d-11e6-a640-0e5557d5dd85',
    'dfp-uuid': 'c0938e97-7588-4b3d-bd60-6f5d6a8b42e3',
    'nominal-moisture': {
      'q': 14,
      'u': 'percent'
    }
  },
  {
    'updated-at': '2018-07-30T18:10:10.000Z',
    'nominal-weight': {
      'q': 32,
      'u': 'pound/bushel'
    },
    'name': 'Cotton',
    'legacy-id': 133130,
    'source': {
      'code': 'agx',
      'id': '13'
    },
    'turnout-percentage': {
      'q': 33,
      'u': 'percent'
    },
    'product-type': 'variety',
    'code': 'cotton',
    'uuid': '6611a51b-487d-11e6-a640-0e5557d5dd85',
    'dfp-uuid': 'b25ebafc-b232-4626-8711-d38c2787abc9',
    'nominal-moisture': {
      'q': 10,
      'u': 'percent'
    }
  },
  {
    'updated-at': '2016-09-21T21:17:18.000Z',
    'nominal-weight': {
      'q': 60,
      'u': 'pound/bushel'
    },
    'name': 'Corn, Sweet',
    'legacy-id': 133171,
    'source': {
      'code': 'agx',
      'id': '54'
    },
    'product-type': 'hybrid',
    'code': 'corn-sweet',
    'uuid': '6611a827-487d-11e6-a640-0e5557d5dd85',
    'dfp-uuid': '88eb42af-348f-4314-8207-c4ea87b78063'
  },
  {
    'updated-at': '2016-09-21T21:17:19.000Z',
    'nominal-weight': {
      'q': 60,
      'u': 'pound/bushel'
    },
    'name': 'Beans, Edible',
    'legacy-id': 150489,
    'product-type': 'variety',
    'code': 'beans-edible',
    'uuid': '6daf6d10-487d-11e6-a640-0e5557d5dd85',
    'dfp-uuid': '096eb460-d56b-448f-96ef-7213c3e5eb94',
    'nominal-moisture': {
      'q': 14.5,
      'u': 'percent'
    }
  },
  {
    'updated-at': '2016-09-21T21:17:19.000Z',
    'nominal-weight': {
      'q': 56,
      'u': 'pound/bushel'
    },
    'name': 'Corn, Seed',
    'legacy-id': 150717,
    'product-type': 'hybrid',
    'code': 'corn-seed',
    'uuid': '6daf6d9c-487d-11e6-a640-0e5557d5dd85',
    'dfp-uuid': '25493096-980c-4e09-a66b-fb435613c106'
  },
  {
    'updated-at': '2018-09-06T17:16:24.000Z',
    'nominal-weight': {
      'q': 60,
      'u': 'pound/bushel'
    },
    'name': 'Wheat, Canada Prairie Spring White',
    'legacy-id': 133423,
    'source': {
      'code': 'agx',
      'id': '374'
    },
    'product-type': 'variety',
    'code': 'wheat-canada-prairie-spring-white',
    'uuid': '6611baa1-487d-11e6-a640-0e5557d5dd85',
    'dfp-uuid': '75480869-f9dd-47ee-aef8-ad1f469a0f05',
    'nominal-moisture': {
      'q': 13.5,
      'u': 'percent'
    }
  },
  {
    'updated-at': '2016-09-21T21:17:18.000Z',
    'nominal-weight': {
      'q': 60,
      'u': 'pound/bushel'
    },
    'name': 'Alfalfa',
    'legacy-id': 133118,
    'source': {
      'code': 'agx',
      'id': '1'
    },
    'product-type': 'variety',
    'code': 'alfalfa',
    'uuid': '6611a3fc-487d-11e6-a640-0e5557d5dd85',
    'dfp-uuid': '196ae648-0063-4aa8-b849-b7b4ac71bb0f'
  },
  {
    'updated-at': '2016-09-21T21:17:18.000Z',
    'nominal-weight': {
      'q': 60,
      'u': 'pound/bushel'
    },
    'name': 'Clover',
    'legacy-id': 133126,
    'source': {
      'code': 'agx',
      'id': '9'
    },
    'product-type': 'variety',
    'code': 'clover',
    'uuid': '6611a4ce-487d-11e6-a640-0e5557d5dd85',
    'dfp-uuid': 'd38f7d56-b245-4f1f-8289-3a82127fe21b',
    'nominal-moisture': {
      'q': 10,
      'u': 'percent'
    }
  },
  {
    'updated-at': '2018-09-06T17:16:24.000Z',
    'nominal-weight': {
      'q': 60,
      'u': 'pound/bushel'
    },
    'name': 'Wheat, Hard Red Spring',
    'legacy-id': 133167,
    'source': {
      'code': 'agx',
      'id': '50'
    },
    'product-type': 'variety',
    'code': 'wheat-hard-red-spring',
    'uuid': '6611a7db-487d-11e6-a640-0e5557d5dd85',
    'dfp-uuid': 'bc52c491-ff7b-477f-9b49-960d3580fc6e',
    'nominal-moisture': {
      'q': 13.5,
      'u': 'percent'
    }
  },
  {
    'updated-at': '2018-09-06T17:16:24.000Z',
    'nominal-weight': {
      'q': 60,
      'u': 'pound/bushel'
    },
    'name': 'Wheat, Hard White Spring',
    'legacy-id': 133437,
    'source': {
      'code': 'agx',
      'id': '390'
    },
    'product-type': 'variety',
    'code': 'wheat-spring',
    'uuid': '6611bba6-487d-11e6-a640-0e5557d5dd85',
    'dfp-uuid': '1fe3c8fd-b290-4f2a-978a-ea0fbff604ba',
    'nominal-moisture': {
      'q': 13.5,
      'u': 'percent'
    }
  },
  {
    'updated-at': '2016-09-21T21:17:18.000Z',
    'nominal-weight': {
      'q': 60,
      'u': 'pound/bushel'
    },
    'name': 'Corn, White',
    'legacy-id': 133179,
    'source': {
      'code': 'agx',
      'id': '62'
    },
    'product-type': 'hybrid',
    'code': 'corn-white',
    'uuid': 'd38ac4aa-18d9-4b79-9574-63967a8ccc1c',
    'dfp-uuid': 'd38ac4aa-18d9-4b79-9574-63967a8ccc1c'
  },
  {
    'updated-at': '2018-10-02T19:46:50.000Z',
    'nominal-weight': {
      'q': 60,
      'u': 'pound/bushel'
    },
    'name': 'Lentils',
    'legacy-id': 133252,
    'source': {
      'code': 'agx',
      'id': '181'
    },
    'product-type': 'variety',
    'code': 'lentils',
    'uuid': '6611ae33-487d-11e6-a640-0e5557d5dd85',
    'dfp-uuid': '00ef33a1-8ea9-4d7f-9d69-7c3980393b02',
    'nominal-moisture': {
      'q': 16,
      'u': 'percent'
    }
  },
  {
    'updated-at': '2016-09-21T21:17:18.000Z',
    'nominal-weight': {
      'q': 60,
      'u': 'pound/bushel'
    },
    'name': 'Mustard',
    'legacy-id': 133335,
    'source': {
      'code': 'agx',
      'id': '280'
    },
    'product-type': 'variety',
    'code': 'mustard',
    'uuid': '6611b43d-487d-11e6-a640-0e5557d5dd85',
    'dfp-uuid': '91f069b9-445b-45e9-b6b0-f1f5c6a5f1e8',
    'nominal-moisture': {
      'q': 8,
      'u': 'percent'
    }
  },
  {
    'updated-at': '2018-07-30T18:10:09.000Z',
    'nominal-weight': {
      'q': 60,
      'u': 'pound/bushel'
    },
    'name': 'Wheat, Hard Red Winter',
    'legacy-id': 133403,
    'source': {
      'code': 'agx',
      'id': '353'
    },
    'product-type': 'variety',
    'code': 'wheat-hard-red-winter',
    'uuid': '6611b92d-487d-11e6-a640-0e5557d5dd85',
    'dfp-uuid': '906f4264-3fae-46ce-97e4-e57506676b6b',
    'nominal-moisture': {
      'q': 13.5,
      'u': 'percent'
    }
  },
  {
    'updated-at': '2018-07-30T18:10:10.000Z',
    'nominal-weight': {
      'q': 60,
      'u': 'pound/bushel'
    },
    'name': 'Peas, Yellow',
    'legacy-id': 162520,
    'product-type': 'variety',
    'code': 'peas-yellow',
    'uuid': '984520c9-667b-11e7-ba9f-0e5557d5dd85',
    'dfp-uuid': 'a8de65bd-bd49-44d2-b827-2c3ef8e1bcf6',
    'nominal-moisture': {
      'q': 16,
      'u': 'percent'
    }
  },
  {
    'updated-at': '2016-09-21T21:17:19.000Z',
    'nominal-weight': {
      'q': 56,
      'u': 'pound/bushel'
    },
    'name': 'Sorghum',
    'legacy-id': 133301,
    'source': {
      'code': 'agx',
      'id': '239'
    },
    'product-type': 'variety',
    'code': 'sorghum',
    'uuid': '6611b1c3-487d-11e6-a640-0e5557d5dd85',
    'dfp-uuid': '396b8b37-c97d-4b17-a2d2-f478eaa52742',
    'nominal-moisture': {
      'q': 13,
      'u': 'percent'
    }
  },
  {
    'updated-at': '2016-09-21T21:17:18.000Z',
    'nominal-weight': {
      'q': 60,
      'u': 'pound/bushel'
    },
    'name': 'Chickpea',
    'legacy-id': 133183,
    'source': {
      'code': 'agx',
      'id': '70'
    },
    'product-type': 'variety',
    'code': 'chickpea',
    'uuid': '6611a90a-487d-11e6-a640-0e5557d5dd85',
    'dfp-uuid': '1e4b6af2-2ca9-45d9-9b71-c4c533cfa54f'
  }
];
